import { ComponentProps } from 'react';

import { cn } from 'src/lib/utils';

import { DialogHeader } from 'src/components/ui/dialog';

export default function CustomModalHeader({
  className,
  ...props
}: ComponentProps<'div'>) {
  return (
    <DialogHeader className={cn('tw:p-4 tw:text-left', className)} {...props} />
  );
}
